module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row no-gutters">\n    ';
 if (featureImageUrl !== "") { 
__p+='\n      ';
 if (description !== "") { 
__p+='\n      <div class="col-xs-12">\n        <img class="img-responsive" src="'+
((__t=( featureImageUrl ))==null?'':__t)+
'">\n      </div>\n      <div class="col-xs-12 feature-popup-content-text-padding">\n      ';
 } else { 
__p+='\n      <div class="col-xs-12">\n        <img class="img-responsive" src="'+
((__t=( featureImageUrl ))==null?'':__t)+
'">\n      </div>\n      <div class="col-xs-12">\n      ';
 } 
__p+='\n    ';
 } else { 
__p+='\n    <div class="col-xs-12">\n    ';
 } 
__p+='\n    <div class="container-fluid">\n      <div class="row">\n        <div class="col-xs-12">\n          '+
((__t=( title ))==null?'':__t)+
'\n        </div>\n        <div class="col-xs-12">\n          '+
((__t=( description ))==null?'':__t)+
'\n        </div>\n        <div class="col-xs-12">\n          <div class="feature-popup-content-more-info-btn"></div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/locations-map/feature-popup-content/feature-popup-content-default-view.tpl
 ** module id = 281
 ** module chunks = 1 7 9 32 51 143 203
 **/